import React from 'react'
import { Flex } from '@/components/atoms/Grid'
import styled from 'styled-components'
import { validFor } from '@/theme/validFor'
import { TabWidth } from './tab'

type TabsProps = {
  tabWidth?: TabWidth | number | string
  underline?: boolean
  value: string
  setValue: (value: string) => void
} & Rest

const Tabs: React.FC<TabsProps> = ({
  value,
  setValue,
  tabWidth = TabWidth.Auto,
  underline = true,
  children,
  ...rest
}) => {
  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        value,
        setValue,
        tabWidth,
        underline
      })
    }
    return child
  })

  return (
    <StyledFlex
      tabWidth={tabWidth}
      flexWrap="wrap"
      alignItems="stretch"
      py={3}
      {...rest}
    >
      {childrenWithProps}
    </StyledFlex>
  )
}

export default Tabs

const StyledFlex = styled(Flex)`
  justify-content: ${({ tabWidth }) =>
    tabWidth === TabWidth.Auto || tabWidth === TabWidth.FullWidth
      ? 'space-around'
      : 'start'};
  ${validFor.mobile`
    ${({ tabWidth }) =>
      tabWidth === TabWidth.Auto ? '' : 'justify-content: start'};
  `}
`
